import { render, staticRenderFns } from "./fwxm.vue?vue&type=template&id=02fb3cfc&scoped=true&"
import script from "./fwxm.vue?vue&type=script&lang=js&"
export * from "./fwxm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fb3cfc",
  null
  
)

export default component.exports